module.exports = __webpack_public_path__ + "static/img/HEADSETS.d03c7d08.png";